import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "psdoc_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      clearToken();
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/register")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const VENDOR_META = {
  fortinet: { label: "Fortinet", color: "#FF3B30" },
  palo_alto: { label: "Palo Alto", color: "#EAE04A" },
  checkpoint: { label: "Check Point", color: "#FF007F" },
  cisco: { label: "Cisco", color: "#00F0FF" },
  other: { label: "Other", color: "#8B949E" },
};

export const DOC_META = {
  hld: { label: "HLD", full: "High-Level Design" },
  lld: { label: "LLD", full: "Low-Level Design" },
  asbuilt: { label: "AS-BUILT", full: "As-Built Document" },
  cover_letter: { label: "COVER", full: "Cover Letter & Executive Summary" },
  solution_overview: { label: "SOLUTION", full: "Solution Overview & Proposed HLD" },
  proposed_hld: { label: "HLD", full: "Proposed High-Level Design" },
  proposed_lld: { label: "LLD", full: "Proposed Low-Level Design" },
  sow: { label: "SOW", full: "Statement of Work" },
  bom: { label: "BOM", full: "Bill of Materials" },
  assumptions: { label: "ASSUMP.", full: "Assumptions, Dependencies & Exclusions" },
  discovery_appendix: { label: "CHECKLIST", full: "Discovery Checklist (Appendix)" },
  ism_matrix: { label: "ISM", full: "ISM Controls Matrix" },
  e8_maturity: { label: "E8", full: "Essential Eight Maturity Rating" },
  pspf_alignment: { label: "PSPF", full: "PSPF Alignment Summary" },
  fortinet_hardening: { label: "HARDENING", full: "FortiGate Hardening Check" },
  assessment_report: { label: "REPORT", full: "Security Assessment Report" },
};

export const DELIVERY_ORDER = ["hld", "lld", "asbuilt"];
export const ASSESSMENT_ORDER = ["asbuilt", "ism_matrix", "e8_maturity", "pspf_alignment", "fortinet_hardening", "assessment_report"];
export const PRESALES_ORDER = ["cover_letter", "solution_overview", "proposed_hld", "proposed_lld", "sow", "bom", "assumptions", "discovery_appendix"];
export const NON_APPROVAL_DOC_TYPES = ["topology", "diagram", "discovery_appendix"];

export default api;
